import {
  productSummaryPageNestHubMaxView,
  productSummaryPageNestHubView,
  productSummaryPageMobileView,
  productSummaryPageTabView,
} from "./pageVariables";
import CartObject from "../helpers/cartUtil";
import Util from "../helpers/util";
// Using shared singleton instance
var UtilObject = new Util();

import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";

var vendorProducts;
var vendor;
var CartDetails = {};
var itemExistsInCart = false,
  productInCart;
var vendorFromOrder;
var p = {};

var selected_value = 0;

export default class ProductSummary {
  constructor() {
    var screenWidth = $(window).width();

    // if (screenWidth > 1023 && screenWidth < 1280) {
    //   $(".productSummaryPage").append(productSummaryPageNestHubView);
    // } else if (screenWidth >= 1280) {
    //   $(".productSummaryPage").append(productSummaryPageNestHubMaxView);
    // } else if (screenWidth > 819 && screenWidth <= 1023) {
    //   $(".productSummaryPage").append(productSummaryPageTabView);
    // } else {
    //   $(".productSummaryPage").append(productSummaryPageMobileView);
    // }

    // Show skeleton, hide content initially
    $("#productSummarySkeleton").removeClass("d-none");
    $("#productSummaryMainContent").addClass("d-none");

    if (screenWidth < 992) {
      $(".displayDuringDesktopViewProductSummaryV2").addClass("d-none");
      $(".displayDuringMobViewProductSummary").removeClass("d-none");
    } else {
      $(".displayDuringMobViewProductSummary").addClass("d-none");
      $(".displayDuringDesktopViewProductSummaryV2").removeClass("d-none");
    }

    this.inputReviewname = $(".inputReviewname");
    this.inputReviewdescription = $(".inputReviewdescription");
    this.inputReviewnameError = $(".inputReviewnameError");
    this.productNotPurchasedError = $(".productNotPurchasedError");
    this.inputReviewdescriptionError = $(".inputReviewdescriptionError");
    this.inputReviewStarRatingError = $(".ratingErrorMsg");
    this.productReviewForm = $("#productReviewForm");

    //+
    this.plusBtnId = $("#plusBtnId");
    //text-field
    this.qntyTextField = $(".qntyTextField");
    //-
    this.minusBtnId = $("#minusBtnId");
    //max error msg
    this.maxErrorMsg = $("#maxErrorMsg");

    //review modal
    this.submitreviewBtn = $(".submitreviewBtn");
    this.ratingbtn = $(".btnrating");
    this.commentReviewUserCheck = $(".commentReviewUserCheck");

    //productId
    this.Product_ID = $("div.productSummaryPage").attr("value");

    //Calculating the Number of products in the cart
    this.noOfProductsInCart = {
      Products: [],
      Products_Not_Available: [],
      vendor: null,
    };
    vendorProducts = this.noOfProductsInCart.Products;
    vendorFromOrder = this.noOfProductsInCart.vendor;
    //if product = [] then deleteCart - write code for this
    if (vendorFromOrder != null && vendorProducts.length == 0) {
      this.deleteEntireCart();
    }

    var allCookies = UtilObject.getAllCookies();

    //Adding the cookies to CartDetails global
    CartDetails["ORDER_ID"] = UtilObject.getCookie("ORDER_ID");
    CartDetails["CUSTOMER_ID"] = UtilObject.getCookie("CUSTOMER_ID");
    $("a.continueShoppingBtn").on("click", this.maintainFlow);

    // Registering Events
    if (this.Product_ID == "") {
      $("div.emptyProductSummaryPage").removeClass("d-none");
    } else {
      $("div.productSummaryPage").removeClass("d-none");
      this.bindEvents();
    }

    document.addEventListener("cart-updated", this.refreshCartCount);
  }

  maintainFlow = () => {
    var allCookies = UtilObject.getAllCookies();

    //window.location = allCookies.PREVIOUS_PAGE;
    history.go(-1);
  };

  bindEvents = () => {
    // Proceed to Cart
    $(".proceedToCartBtn")
      .off("click")
      .on("click", () => {
        window.location.href = baseURL + "customer/cart";
      });

    this.minusBtnId.on("click", this.minusItemFunction);
    this.plusBtnId.on("click", this.plusItemFunction);
    this.submitreviewBtn.on("click", this.submitreview);
    this.commentReviewUserCheck.on("click", this.commentReviewUserCheckx);
    this.ratingbtn.on("click", this.btnrating);
    $(".addToCartProductSummary").on("click", this.addNewitemToCart);

    // Trigger instead of waiting for load
    this.getProductSummary();
    //$(window).on("load", () => { this.getProductImages(); });

    //Validations for Modalif Cart Items are different.
    $(".keepOldCart").on("click", () => {
      bootstrap.Modal.getOrCreateInstance("#showCartModal").hide();
    });

    $(".reviewViewMoreBtn").on("click", () => {
      if ($(".reviewViewMoreBtn").html() == "View More") {
        $(".reviewViewMoreBtn").html("View Less");
      } else {
        $(".reviewViewMoreBtn").html("View More");
      }
    });

    $(".startNewCart").on("click", async () => {
      bootstrap.Modal.getOrCreateInstance("#showCartModal").hide();
      this.deleteEntireCart();
      await CartObject.cartCheck();

      this.addtoCart(p, "ADD");
      CartObject.notifyCartUpdate();
      // setTimeout(() => {
      //   window.location.reload();
      // }, 100);
    });

    this.refreshCartCount();

    //button to close window if user has not purchased the item
    $(".productReviewClose").on("click", () => {
      bootstrap.Modal.getOrCreateInstance("#productNotPurchased").hide();
      //   setTimeout(()=>{
      //     window.location.reload();
      //  }, 50);
    });

    $(".reviewprodductModalClose").on("click", () => {
      bootstrap.Modal.getOrCreateInstance("#reviewModal").hide();
      //   setTimeout(()=>{
      //     window.location.reload();
      //  }, 50);
    });

    $("#customerNotLoggedforReviewClose").on("click", () => {
      bootstrap.Modal.getOrCreateInstance("#customerNotLoggedforReview").hide();
      //   setTimeout(()=>{
      //     window.location.reload();
      //  }, 50);
    });

    $(".buyNow").on("click", this.buyProductNow);
  };

  //check if the user has made the purchase to review
  commentReviewUserCheckx = () => {
    var customer = UtilObject.getAllCookies();

    $.ajax({
      url:
        globalThis.baseURL +
        "api/customer/ProductSummary/checkUserPurchasedItem",
      type: "POST",

      data: {
        Customer_ID: customer.CUSTOMER_ID,
        Product_ID: this.Product_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        var code = res.code;

        if (code == 70) {
          bootstrap.Modal.getOrCreateInstance("#reviewModal").show();
        } else if (code == 99) {
          bootstrap.Modal.getOrCreateInstance("#productNotPurchased").show();
        } else if (code == 18) {
          bootstrap.Modal.getOrCreateInstance("#customerNotLoggedforReview").show();
        }
      },
      error: (err) => {
        console.error("Purchase check failed", err);
      },
    });
  };

  refreshCartCount = async (forceRefresh = false) => {
    this.noOfProductsInCart = await CartObject.cartCheck(forceRefresh);
    vendorProducts = this.noOfProductsInCart.Products;
    vendorFromOrder = this.noOfProductsInCart.vendor;

    if (this.noOfProductsInCart && this.noOfProductsInCart.Products) {
      const count = this.noOfProductsInCart.Products.length;
      $("span.cartCount").html(`${count}`);

      if (count > 0) {
        $(".proceedToCartBtn").removeClass("d-none");
      } else {
        $(".proceedToCartBtn").addClass("d-none");
      }
    } else {
      $("span.cartCount").html(`0`);
      $(".proceedToCartBtn").addClass("d-none");
    }
  };

  submitreview = (e) => {
    e.preventDefault();

    let isReviewnameValidated = this.Reviewname_validate();
    if (isReviewnameValidated) {
      this.inputReviewnameError.html("");
    }

    let isReviewdescriptionValidated = this.Reviewdescription_validate();
    if (isReviewdescriptionValidated) {
      this.inputReviewdescriptionError.html("");
    }

    let isReviewStarRatingValidated = this.ReviewRating_validate();
    if (isReviewStarRatingValidated) {
      this.inputReviewStarRatingError.html("");
    }

    if (
      isReviewnameValidated &&
      isReviewdescriptionValidated &&
      isReviewStarRatingValidated
    ) {
      this.productReviewSubmit_Form();
    }
  };

  ReviewRating_validate = () => {
    let flag = true;

    if (selected_value == 0) {
      this.inputReviewStarRatingError.html("Select rating");
      flag = false;
    }

    return flag;
  };

  Reviewname_validate = () => {
    let flag = true;

    if (this.inputReviewname.val().length < 5) {
      this.inputReviewnameError.html(
        "Review Name should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  Reviewdescription_validate = () => {
    let flag = true;

    if (this.inputReviewdescription.val().length < 5) {
      this.inputReviewdescriptionError.html(
        "Review description should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  //submit button for review
  productReviewSubmit_Form = () => {
    var customer = UtilObject.getAllCookies();

    $.ajax({
      url: globalThis.baseURL + "api/customer/ProductSummary/addProductReview",
      type: "POST",

      data: {
        Customer_ID: customer.CUSTOMER_ID,
        Product_ID: this.Product_ID,
        Review_Title: this.inputReviewname.val(),
        Review_Description: this.inputReviewdescription.val(),
        Review_Score: selected_value,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        bootstrap.Modal.getOrCreateInstance("#reviewModal").hide();
        location = self.location;
      },
      error: (err) => {
        var code = err.responseJSON.code;

        if (code == 18) {
          alert("Customer Not logged In");
          location = self.location;
        } else if (code == 99) {
          //this.productNotPurchasedError.html("YOU HAVE NOT PURCHASED THE ITEM");
          // location = self.location;
          bootstrap.Modal.getOrCreateInstance("#reviewModal").hide();
          bootstrap.Modal.getOrCreateInstance("#productNotPurchased").show();
        }
      },
    });
  };

  //plusItemFunction
  plusItemFunction = () => {
    var maxQuantity = $(".qntyTextField").attr("max");
    maxQuantity = parseInt(maxQuantity);
    var currentQuantity = $(".qntyTextField").val();
    currentQuantity = parseInt(currentQuantity);
    var newQuantity = currentQuantity + 1;

    // if (itemExistsInCart == true) {

    // } else {

    // }

    // this.qntyTextField.val().disabled = true;

    //validation for + btn
    if (newQuantity > maxQuantity) {
      $(".maxErrorMsg").html("Maximum Quantity Reached");
      $("#maxErrorMsgV2").html("Maximum Quantity Reached");
      $(".qntyTextField").attr("value", currentQuantity).html(currentQuantity);
    } else {
      $(".maxErrorMsg").html("");
      $("#maxErrorMsgV2").html("");
      if (itemExistsInCart == true) {
        p.Product_ID = this.Product_ID;
        p.Quantity = newQuantity;
        p.Total_Items = this.noOfProductsInCart.Products.length;

        this.addtoCart(p, "UPDATE_QTY");
        $(".qntyTextField").attr("value", newQuantity);
        $(".qntyTextField").html(newQuantity);
        //this.qntyTextField.val() = newQuantity;
      } else {
        $(".qntyTextField").attr("value", newQuantity);
        $(".qntyTextField").html(newQuantity);
        //this.qntyTextField.val() = newQuantity;
      }
    }
    CartObject.notifyCartUpdate();
  };

  //miuusItemFunction
  minusItemFunction = () => {
    var p = {};
    var minQuantity = 1;
    //maxQuantity = parseInt(maxQuantity);
    var currentQuantity = $(".qntyTextField").val();
    currentQuantity = parseInt(currentQuantity);
    var newQuantity = currentQuantity - 1;

    if (newQuantity < 1) {
      $(".maxErrorMsg").html("Minimum Quantity Should be One");
      $("#maxErrorMsgV2").html("Minimum Quantity Should be One");
      $(".qntyTextField").attr("value", 1).html(1);
    } else {
      $(".maxErrorMsg").html("");
      $("#maxErrorMsgV2").html("");
      if (itemExistsInCart == true) {
        p.Product_ID = this.Product_ID;
        p.Quantity = newQuantity;
        p.Total_Items = this.noOfProductsInCart.Products.length;

        this.addtoCart(p, "UPDATE_QTY");
        $(".qntyTextField").attr("value", newQuantity);
        $(".qntyTextField").html(newQuantity);
      } else {
        $(".qntyTextField").attr("value", newQuantity);
        $(".qntyTextField").html(newQuantity);
      }
    }
    CartObject.notifyCartUpdate();
  };

  removeProductFromCart = () => {
    var p = {};

    p.Product_ID = this.Product_ID;
    p.Quantity = 0;
    p.Total_Items = this.noOfProductsInCart.Products.length;
    this.addtoCart(p, "UPDATE_QTY");
    CartObject.notifyCartUpdate();
    UtilObject.showToast("Item removed from cart!", "danger");

    $(".qntyTextField").attr("value", 1).html(1);

    const mobileBtn = `<button type="button" class="btn btn-outline-brand btn-sm w-100 py-2 addToCartProductSummary" style="border-radius: 10px; font-weight: 600;">Add To Cart</button>`;
    const desktopBtn = `<button type="button" class="btn v2-btn addToCartProductSummary text-white w-100" style="background: #3b82f6;">Add To Cart</button>`;

    if ($(window).width() >= 992) {
      $(`.removeFromCart`).replaceWith(desktopBtn);
    } else {
      $(`.removeFromCart`).replaceWith(mobileBtn);
    }

    $(".addToCartProductSummary")
      .off("click")
      .on("click", this.addNewitemToCart);

    itemExistsInCart = false;

    //UtilObject.eraseCookie("ORDER_ID");

    $("button.buyNow").show();
  };

  buyProductNow = () => {
    var p = {};
    var currentQuantity = $(".qntyTextField").val();

    p.Product_ID = this.Product_ID;
    p.Quantity = currentQuantity;
    p.Total_Items = this.noOfProductsInCart.Products.length;

    if (itemExistsInCart == true) {
      this.addNewitemToCartBuyNow();
    } else {
      this.addNewitemToCartBuyNow();
    }

    //window.location = baseURL + "customer/cart";
  };

  btnrating = (event) => {
    // //validation for - btn

    var previous_value = $("#selected_rating").val();

    selected_value = $(event.currentTarget).attr("data-attr");

    $("#selected_rating").val(selected_value);

    $(".selected-rating").empty();
    $(".selected-rating").html(selected_value);

    for (var i = 1; i <= selected_value; ++i) {
      $("#rating-star-" + i).toggleClass("btn-warning");
      $("#rating-star-" + i).toggleClass("btn-default");
    }

    for (var ix = 1; ix <= previous_value; ++ix) {
      $("#rating-star-" + ix).toggleClass("btn-warning");
      $("#rating-star-" + ix).toggleClass("btn-default");
    }
  };

  // product summary
  getProductSummary = () => {
    $.ajax({
      url: globalThis.baseURL + "api/customer/ProductSummary/getProductSummary",
      type: "POST",

      data: {
        Product_ID: this.Product_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: this.showProductDetails,
      error: (result) => {
        $("#productSummarySkeleton").addClass("d-none");
        $("#productSummaryMainContent").removeClass("d-none");
      },
    });
  };

  showProductDetails = async (res) => {
    var screenWidth = $(window).width();

    //for vendor on product summary page
    $.ajax({
      url:
        globalThis.baseURL +
        "api/customer/ProductSummary/getVendorDetailsProductSummary",
      type: "POST",

      data: {
        Vendor_ID: res.Vendor_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: async (result) => {
        vendor = result.vendor;

        //Star based on rating for the vendor section
        let vendorRating = result.vendor.Vendor_Rating;
        vendorRating = Math.round(vendorRating * 2) / 2;
        let vendorOutput = [];

        // Append all the filled whole stars
        for (var i = vendorRating; i >= 1; i--)
          vendorOutput.push(
            `<i class="fa fa-star" aria-hidden="true" style="color: gold;"></i>`,
          );
        // If there is a half a star, append it
        if (i == 0.5)
          vendorOutput.push(
            `<i class="fa fa-star-half-o" aria-hidden="true" style="color: gold;"></i>`,
          );
        // Fill the empty stars
        for (let i = 5 - vendorRating; i >= 1; i--)
          vendorOutput.push(
            `<i class="fa fa-star-o" aria-hidden="true" style="color: gold;"></i>`,
          );

        vendorOutput = vendorOutput.join("");

        //vendor details
        //     var pdetail = `  <div class="card-header">
        //     <h4><strong>Sold By</strong></h4>
        // </div>
        // <div class="card-body text-dark">
        //     <div class="row">
        //         <div class="col-6 d-flex justify-content-start">
        //         <img src="${baseURL}/assets/src/images/${
        //       result.vendor.Image_URL
        //     }" class="img-fluid rounded-start rounded-end" width="210" height="150" alt=" Responsive image">
        //         </div>

        //         <div class="col">

        //             <h4 class="card-title">
        //                 ${result.vendor.Business_Name}
        //             </h4>
        //             <h5 class="card-title">${
        //               result.vendor.Address.Address_Line_1 +
        //               ", " +
        //               result.vendor.Address.State
        //             }</h5>
        //             <h6 class="card-title">Minimum Order:${
        //               result.vendor.Minimum_Order
        //             }</h6>
        //             <h6 class="card-title">${result.vendor.Vendor_Rating} stars</h6>
        //             <h6 class="card-title">${vendorOutput}</h6>
        //         </div>
        //     </div>
        // </div> `;
        //     $(".productVendorDetails").append(pdetail);

        // //product Details

        // var vendorname = result.vendor.Business_Name;
        // $(".productvendorName").append(vendorname);

        //new product details
        const vendorImg = getVendorBusinessImageUrl(vendor.Image_URL);

        $(".soldByVendorImage").attr("src", vendorImg);

        $(".soldByVendorRatingStar").html(vendorOutput);
        $(".soldByVendorName").html(vendor.Business_Name);
        $(".soldByVendorAddress").html(
          `${vendor.Address.City + ", " + vendor.Address.State}`,
        );
        $(".soldByMinimumOrder").html(vendor.Minimum_Order);
        $(".vendorPageRelocate").attr(
          "href",
          `${globalThis.baseURL}customer/productListing/${vendor.Vendor_URL}`,
        );

        // Populate Content
        $(".productName").html(res.Product_Service_Name);
        $(".productPrice").html(res.Price);
        $(".productDescription").html(res.Description);

        $(".productNameV2").html(res.Product_Service_Name);
        $(".productPriceV2").html(res.Price);
        $(".productDescriptionV2").html(res.Description);
        $(".soldByVendorNameV2").html(vendor.Business_Name);

        // Populate Images Early
        const productImg = getImageUrl(res.Image_URL);
        $(".landingPageProductImage").attr("src", productImg);
        $(".landingPageProductImageV2").attr("src", productImg);

        // Remove Skeleton
        setTimeout(() => {
          $("#productSummarySkeleton").fadeOut(300, () => {
            $("#productSummarySkeleton").addClass("d-none");
            $("#productSummaryMainContent")
              .removeClass("d-none")
              .hide()
              .fadeIn(400);
          });
        }, 100);
      },
      error: function (result) {
        $("#productSummarySkeleton").addClass("d-none");
        $("#productSummaryMainContent").removeClass("d-none");
      },
    });

    //to show button if nonvegflag is set = 0 is veg and 1 is non-veg
    // var color = "text-primary";

    // if (res.hasOwnProperty("Veg_NonVeg_flag")) {
    //   if (res.Veg_NonVeg_flag == "Non-Veg") {
    //     color = "text-danger";
    //   } else {
    //     color = "text-success";
    //   }
    // }
    if (res.Veg_NonVeg_flag != false) {
      const dietClass = res.Veg_NonVeg_flag == 0 ? "veg" : "non-veg";
      const dietLabel = res.Veg_NonVeg_flag == 0 ? "Veg" : "Non-Veg";
      var value = `
        <div class="d-flex align-items-center gap-2">
          <div class="diet-icon ${dietClass}" title="${dietLabel}">
            <div class="dot"></div>
          </div>
          <span class="small fw-bold text-muted text-uppercase" style="letter-spacing: 0.05em; font-size: 0.65rem;">${dietLabel}</span>
        </div>`;
      $(".vegOrNonVegSymbol").html(value);
    }

    //new peoduct rating
    //Star based on rating for the product section
    // let productRating = res.Product_Review_Score;
    // productRating = Math.round(productRating * 2) / 2;
    // let productRatingOutput = [];

    // // Append all the filled whole stars
    // for (var i = productRating; i >= 1; i--)
    //   productRatingOutput.push(
    //     `<i class="fa fa-star" aria-hidden="true" style="color: white;"></i>`
    //   );
    // // If there is a half a star, append it
    // if (i == 0.5)
    //   productRatingOutput.push(
    //     `<i class="fa fa-star-half-o" aria-hidden="true" style="color: white;"></i>`
    //   );
    // // Fill the empty stars
    // for (let i = 5 - productRating; i >= 1; i--)
    //   productRatingOutput.push(
    //     `<i class="fa fa-star-o" aria-hidden="true" style="color: white;"></i>`
    //   );

    // productRatingOutput = productRatingOutput.join("");
    // //productname
    // var pname = `<h3 class="text-white">${res.Product_Service_Name} </h3>
    // <h5 class="text-white">${res.Product_Speciality}</h5>
    // <br>
    // <h5 class="text-white productvendorName" style="color: grey;"> </h5>
    // <br>

    // <div class="container-fluid  p-0">
    //     <div class="row d-flex justify-content-around">
    //         <div class="col-3">
    //             <h5 class="fw-normal  text-white"><i class="fa fa-star" style="color: white;"></i>${res.Product_Review_Score}</h5>

    //         </div>
    //         <div class="col-3">
    //         <h5 class="fw-normal  text-white">₹ ${res.Price} </h5>

    //         </div>
    //        <!-- <div class="col-3">
    //         <h5 class="fw-normal  text-white"><i class="fa fa-truck" aria-hidden="true"></i>Free Delivery</h5>

    //         </div>-->
    //     </div>

    //     <div class="row  mt-2">
    //             <div class="col-4 w-100 d-md-block mt-4 d-flex justify-content-center">
    //             <button type="button" class="btn notaVegNonVeg ${vegNonvegBtnColor} btn ml-1 mt-4">${value}</button>
    //             <button type="button" class="btn btn-light btn ml-1 mt-4" data-bs-toggle="modal" data-bs-target="#viewProductPhotos">View photos</button>
    //             <a href="#review"><button type="button" class="btn btn-light btn ml-1 mt-4">View reviews</button></a>
    //             </div>
    //         </div>
    // </div>`;
    // $(".productSummaryDetails").append(pname);
    // // to hide button if nonvegflag is not set

    // //product description
    // var pdescription = `<p class="card-text">${res.Description}</p>`;
    // $(".productDescription").append(pdescription);

    if (res.Product_Review_Score > 0) {
      //for vendor review stars
      let productRating = res.Product_Review_Score;
      productRating = Math.round(productRating * 2) / 2;
      let productRatingOutput = [];

      // Append all the filled whole stars
      for (var i = productRating; i >= 1; i--)
        productRatingOutput.push(
          `<i class="fa fa-star" aria-hidden="true" style="color: white;"></i>`,
        );
      // If there is a half a star, append it
      if (i == 0.5)
        productRatingOutput.push(
          `<i class="fa fa-star-half-o" aria-hidden="true" style="color: white;"></i>`,
        );
      // Fill the empty stars
      for (let i = 5 - productRating; i >= 1; i--)
        productRatingOutput.push(
          `<i class="fa fa-star-o" aria-hidden="true" style="color: white;"></i>`,
        );

      productRatingOutput = productRatingOutput.join("");
      if (screenWidth >= 992) {
        $(".productRatingV2").html(productRatingOutput);
      } else if (screenWidth > 576) {
        $(".productRating").html(productRatingOutput);
      } else {
        $(".productRatingMobile").html(
          res.Product_Review_Score +
            '<i class="fa fa-star" aria-hidden="true" style="color: white;"></i>',
        );
      }
    } else {
      let vendorNoOutput = [];
      for (var stars = 5; stars >= 1; stars--)
        vendorNoOutput.push(
          `<i class="fa-regular fa-star" aria-hidden="true" style="color: #cbd5e1;"></i>`,
        );
      vendorNoOutput = vendorNoOutput.join("");

      if (screenWidth >= 992) {
        $(".productRatingV2").html(vendorNoOutput);
      } else if (screenWidth > 576) {
        $(".productRating").html(vendorNoOutput);
      } else {
        $(".productRatingMobile").html(vendorNoOutput);
      }
    }

    //product reviews
    //
    if (res.hasOwnProperty("Reviews")) {
      if (res.Reviews.length == 0) {
        $(".reviewViewMoreBtn").hide();
        $(".reviewError").html(`
          <div class="text-center py-4">
            <i class="fa-regular fa-comments fa-2x mb-2 text-muted opacity-50"></i>
            <p class="text-muted small">No reviews yet. Be the first to share your experience!</p>
          </div>
        `);
      } else if (res.Reviews.length > 0) {
        if (res.Reviews.length < 3) {
          $(".reviewViewMoreBtn").hide();
        }
        var counter = 0;
        res.Reviews.forEach((element) => {
          //Getting Stars based on review rating for the review section
          let reviewRating = element.Review_Score;
          reviewRating = Math.round(reviewRating * 2) / 2;
          let reviewOutput = [];

          // Append all the filled whole stars
          for (var i = reviewRating; i >= 1; i--)
            reviewOutput.push(
              `<i class="fa fa-star" aria-hidden="true" style="color: gold;"></i>`,
            );
          // If there is a half a star, append it
          if (i == 0.5)
            reviewOutput.push(
              `<i class="fa fa-star-half-o" aria-hidden="true" style="color: gold;"></i>`,
            );
          // Fill the empty stars
          for (let i = 5 - reviewRating; i >= 1; i--)
            reviewOutput.push(
              `<i class="fa fa-star-o" aria-hidden="true" style="color: gold;"></i>`,
            );
          //
          reviewOutput = reviewOutput.join("");

          //getting customer
          $.ajax({
            url: baseURL + "api/customer/Account/GetUserDetails",
            type: "POST",

            data: {
              Customer_ID: element.Customer_ID,
            },
            headers: { Authorization: X_API_KEY },
            success: (result) => {
              //Review
              var item = `
          <div class="row">
          <div class="col">
          <h4 class="card-title">${result.Customer_Name}</h4>
          </div>
          <div class="col">
          <div class="ratings text-right"><span>${reviewOutput}</span>
          </div>
          </div>
          <h5 class="card-title">${element.Review_Title}</h5>
          <p class="card-text">${element.Review_Description}</p>
          </div>
          <hr style="width:auto;">`;
              if (counter < 3) {
                $(".productReviews").append(item);
              } else {
                $("#productReviewsMore").append(item);
              }
              counter += 1;
            },
            error: function (result) {},
          });
        });
      }
    } else {
      $(".reviewViewMoreBtn").hide();
      $(".reviewError").html("No reviews yet..");
    }

    //
    // if ($(".reviewViewMoreBtn").val()=="viewMore"){
    //   $(".reviewViewMoreBtn").html("View More")
    // }else{
    //   $(".reviewViewMoreBtn").html("View Less")
    // }

    //Check if product already exists in cart\

    vendorProducts.forEach((product) => {
      if (product.Product_ID === res.Product_ID) {
        itemExistsInCart = true;
        productInCart = product;
      }
    });

    if (itemExistsInCart == true) {
      var cartItem = `<li class="page-item"><button class="page-link minusButton" value="${productInCart.Product_ID}">-
        </button>
    </li>

    <li class="page-item"><button min="0" max="${productInCart.Product_Details.Quantity}" name="${productInCart.Product_ID}" value="${productInCart.Quantity}" type="number" class="page-link quantityButton qntyTextField" disabled>${productInCart.Quantity}</button>
    </li>

    <li class="page-item"> <button class="page-link plusButton" value="${productInCart.Product_ID}">+

        </button>
    </li>`;
      $(".productDetailsInCart").html(cartItem);
      //$(".qntyTextField").val(product.Quantity);
      $(".minusButton").off("click");
      $(".minusButton").on("click", this.minusItemFunction);
      $(".plusButton").off("click");
      $(".plusButton").on("click", this.plusItemFunction);

      const removeBtn = `<button type="button" class="btn v2-btn text-white removeFromCart w-100" style="background: #ff385c;">Remove from Cart</button>`;
      $(`.addToCartProductSummary`).replaceWith(removeBtn);
      $("button.buyNow").hide();
      $(".buyNowBtnV2").hide();
      $(".proceedToCartBtn").removeClass("d-none");
      $(".removeFromCart").off("click");
      $(".removeFromCart").on("click", this.removeProductFromCart);
    } else {
      if (res.Quantity <= 0) {
        $(".productsAvailable").addClass("d-none");
        $(".productsNotAvailable").removeClass("d-none");
      } else {
        var cartItem = `<li class="page-item"><button class="page-link minusButton" value="${res.Product_ID}">-
        </button>
    </li>

    <li class="page-item"><button min="0" max="${res.Quantity}" name="${res.Product_ID}" value="1" type="number" class="page-link quantityButton qntyTextField" disabled>1</button>
    </li>

    <li class="page-item"> <button class="page-link plusButton" value="${res.Product_ID}">+

        </button>
    </li>`;
        $(".productDetailsInCart").html(cartItem);
        //$(".qntyTextField").val(product.Quantity);
        $(".minusButton").off("click");
        $(".minusButton").on("click", this.minusItemFunction);
        $(".plusButton").off("click");
        $(".plusButton").on("click", this.plusItemFunction);
      }
    }

    //product images
    const productImg = getImageUrl(res.Image_URL);

    $(".landingPageProductImage").attr("src", productImg);

    this.productImageCarousel(res.Image_URL);

    // //product image count
    // $(".imagesCountProduct").html(`+${result.length - 3}`);
    // if (result.length == 3) {
    //   $(".imagesCountProduct").hide();
    // }

    //for product image carousel
    //for first active image
    // var activeitem = `<div class="carousel-item active ">
    //     <img src="${productImageArrayy[1]}" class="d-block " alt="" width="100%">
    //     </div>`;

    // $(".productImageCarouselActiveItem").append(activeitem);

    //for remaining images
    // productImageArrayy.forEach((productImageArrayy) => {
    //   var item = `
    //     <div class="carousel-item">
    //         <img src="${productImageArrayy}" class="d-block " alt="" width="100%">
    //     </div>`;
    //   $(".productImageCarousel").append(item);
    // });

    //product iamge end
  };

  productImageCarousel = (ImageUrl) => {
    if (!ImageUrl) return;

    $(".productImagesCarousel").empty();
    $(".product-mobile-gallery").empty();
    $(".product-thumbnails-desktop").empty();

    const screenWidth = $(window).width();
    if (screenWidth < 576) {
      $(".moreImagesMobile").removeClass("d-none");
    } else {
      $(".moreImagesDesktop").removeClass("d-none");
    }

    const normalizedImageUrl = String(ImageUrl).replace(/^\/+/, "");
    const parts = normalizedImageUrl.split("/");
    const fileName = parts.pop();
    const basePath = parts.length > 0 ? parts.join("/") + "/" : "";

    // In a real scenario, we might have an array of images.
    // For now, we follow the legacy pattern of assuming 01.png, 02.png etc exists if not available.
    // However, we'll at least put the primary image first.

    const imagesToLoad = [ImageUrl];
    for (let j = 2; j <= 3; j++) {
      imagesToLoad.push(basePath + `0${j}.png`);
    }

    const checkImages = imagesToLoad.map((path, index) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve({ index, path: getImageUrl(path) });
        img.onerror = () => resolve(null);
        img.src = getImageUrl(path);
      });
    });

    Promise.all(checkImages).then((results) => {
      const validImages = results
        .filter((r) => r !== null)
        .sort((a, b) => a.index - b.index);

      validImages.forEach((imgObj, i) => {
        const imageUrl = imgObj.path;
        const active = i === 0 ? "active" : "";

        // Modal gallery
        $(".productImagesCarousel").append(`
          <div class="carousel-item ${active}">
            <img src="${imageUrl}" class="d-block w-100">
          </div>
        `);

        // Mobile gallery
        if (screenWidth < 992) {
          $(".product-mobile-gallery").append(`
            <div class="item">
              <img src="${imageUrl}" class="img-fluid" style="width: 100%; aspect-ratio: 1/1; object-fit: contain; background: #fff;">
            </div>
          `);
        }

        // Desktop V2 Gallery
        if (screenWidth >= 992) {
          if (i === 0) {
            $(".landingPageProductImageV2").attr("src", imageUrl);
          }
          $(".product-thumbnails-desktop").append(`
            <img src="${imageUrl}" class="thumb-v2 ${active}" data-large="${imageUrl}">
          `);
        }
      });

      // Desktop Thumbnail Switcher Logic
      if (screenWidth >= 992) {
        $(".thumb-v2").on("click", (e) => {
          const $thumb = $(e.currentTarget);
          const largeUrl = $thumb.data("large");

          $(".thumb-v2").removeClass("active");
          $thumb.addClass("active");

          const $mainImg = $(".landingPageProductImageV2");
          $mainImg.addClass("swapping");

          setTimeout(() => {
            $mainImg.attr("src", largeUrl);
            setTimeout(() => {
              $mainImg.removeClass("swapping");
            }, 50);
          }, 200);
        });
      }

      // Initialize Owl Carousel (Mobile)
      if (screenWidth < 992 && validImages.length > 0) {
        const $gallery = $(".product-mobile-gallery");
        $gallery.owlCarousel({
          items: 1,
          loop: false,
          margin: 0,
          nav: false,
          dots: true,
          onInitialized: (event) => {
            $(".total-slides").text(validImages.length);
          },
          onChanged: (event) => {
            if (event.item) {
              $(".current-slide").text(event.item.index + 1);
            }
          },
        });
      }
    });
  };

  //this is to add/update cart in db
  addtoCart = async (product, type) => {
    this.noOfProductsInCart = await CartObject.cartCheck();

    //Check if ORDER_ID session cookie exists
    var checkOrderID = UtilObject.getAllCookies();

    if (!checkOrderID.hasOwnProperty("ORDER_ID")) {
      await new Promise((resolve) => {
        $.ajax({
          url:
            globalThis.baseURL +
            "api/customer/CustomerCookies/setRandomSessionId",
          type: "POST",
          data: { name: "ORDER_ID" },
          success: (result) => resolve(result),
          error: (err) => resolve(null),
        });
      });
    }

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/AddtoCart",
      type: "POST",

      data: {
        Vendor_ID: vendor.Vendor_ID,
        Product_ID: product.Product_ID,
        Quantity: product.Quantity,
        Type: type,
        Total_Items: this.noOfProductsInCart.Products.length,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        if (product.Quantity > 0) {
          const removeBtn = `<button type="button" class="btn v2-btn text-white removeFromCart w-100" style="background: #ff385c;">Remove from Cart</button>`;
          const mobileRemoveBtn = `<button type="button" class="btn btn-brand text-white btn-sm w-100 py-2 removeFromCart" style="border-radius: 10px; font-weight: 600;">Remove from Cart</button>`;

          if ($(window).width() >= 992) {
            $(`.addToCartProductSummary`).replaceWith(removeBtn);
          } else {
            $(`.addToCartProductSummary`).replaceWith(mobileRemoveBtn);
          }

          $(".removeFromCart")
            .off("click")
            .on("click", this.removeProductFromCart);

          $(".buyNow").hide();
          $(".buyNowBtnV2").hide();
          $(".proceedToCartBtn").removeClass("d-none");

          itemExistsInCart = true;
          UtilObject.showToast("Item added to cart!", "success");
        }
        this.refreshCartCount(true);
      },
      error: (err) => {
        var errorData = err.responseJSON;

        $(".addToCartErrorMessage").html(errorData.Msg);
        bootstrap.Modal.getOrCreateInstance("#addToCartError").show();
        if (errorData.code == "12") {
          $(".productsAvailable").addClass("d-none");
          $(".productsNotAvailable").removeClass("d-none");
        }
        this.refreshCartCount();
      },
    });
    this.refreshCartCount();
  };

  addNewitemToCart = async () => {
    var currentQuantity = $(".qntyTextField").val();
    currentQuantity = parseInt(currentQuantity);

    // Force real-time check to prevent race conditions
    this.noOfProductsInCart = await CartObject.cartCheck();
    vendorFromOrder = this.noOfProductsInCart.vendor;

    if (vendorFromOrder != null && this.noOfProductsInCart.Products.length > 0) {
      if (vendorFromOrder.Vendor_ID != vendor.Vendor_ID) {
        p.Product_ID = this.Product_ID;
        p.Quantity = currentQuantity;
        p.Total_Items = this.noOfProductsInCart.Products.length;

        bootstrap.Modal.getOrCreateInstance("#showCartModal").show();
      } else {
        p.Product_ID = this.Product_ID;
        p.Quantity = currentQuantity;
        p.Total_Items = this.noOfProductsInCart.Products.length;

        this.addtoCart(p, "ADD");
      }
    } else {
      p.Product_ID = this.Product_ID;
      p.Quantity = currentQuantity;
      p.Total_Items = this.noOfProductsInCart.Products.length;

      this.addtoCart(p, "ADD");
    }
    CartObject.notifyCartUpdate();
  };

  addNewitemToCartBuyNow = async () => {
    var currentQuantity = $(".qntyTextField").val();
    currentQuantity = parseInt(currentQuantity);

    // Force real-time check
    this.noOfProductsInCart = await CartObject.cartCheck();
    vendorFromOrder = this.noOfProductsInCart.vendor;

    if (vendorFromOrder != null && this.noOfProductsInCart.Products.length > 0) {
      if (vendorFromOrder.Vendor_ID != vendor.Vendor_ID) {
        p.Product_ID = this.Product_ID;
        p.Quantity = currentQuantity;
        p.Total_Items = this.noOfProductsInCart.Products.length;

        bootstrap.Modal.getOrCreateInstance("#showCartModal").show();
      } else {
        p.Product_ID = this.Product_ID;
        p.Quantity = currentQuantity;
        p.Total_Items = this.noOfProductsInCart.Products.length;

        this.addtoCartBuyNow(p, "ADD");
      }
    } else {
      p.Product_ID = this.Product_ID;
      p.Quantity = currentQuantity;
      p.Total_Items = this.noOfProductsInCart.Products.length;

      this.addtoCartBuyNow(p, "ADD");
    }
    CartObject.notifyCartUpdate();
  };

  addtoCartBuyNow = async (product, type) => {
    this.noOfProductsInCart = await CartObject.cartCheck();

    //Check if ORDER_ID session cookie exists
    var checkOrderID = UtilObject.getAllCookies();

    if (!checkOrderID.hasOwnProperty("ORDER_ID")) {
      await new Promise((resolve) => {
        $.ajax({
          url:
            globalThis.baseURL +
            "api/customer/CustomerCookies/setRandomSessionId",
          type: "POST",
          data: { name: "ORDER_ID" },
          success: (result) => resolve(result),
          error: (err) => resolve(null),
        });
      });
    }

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/AddtoCart",
      type: "POST",
      data: {
        Vendor_ID: vendor.Vendor_ID,
        Product_ID: product.Product_ID,
        Quantity: product.Quantity,
        Type: type,
        Total_Items: this.noOfProductsInCart.Products.length,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        const removeBtn = `<button type="button" class="btn v2-btn text-white removeFromCart w-100" style="background: #ff385c;">Remove from Cart</button>`;

        $(`.addToCartProductSummary`).replaceWith(removeBtn);
        $(".removeFromCart")
          .off("click")
          .on("click", this.removeProductFromCart);

        $(".buyNow").hide();
        $(".buyNowBtnV2").hide();
        $(".proceedToCartBtn").removeClass("d-none");

        this.refreshCartCount();
        itemExistsInCart = true;
        UtilObject.showToast("Item added to cart!", "success");
        window.location = globalThis.baseURL + "customer/cart";
      },
      error: (err) => {
        var errorData = err.responseJSON;

        $(".addToCartErrorMessage").html(errorData.Msg);
        bootstrap.Modal.getOrCreateInstance("#addToCartError").show();
        if (errorData.code == "12") {
          $(".productsAvailable").addClass("d-none");
          $(".productsNotAvailable").removeClass("d-none");
        }
        this.refreshCartCount();
      },
    });
    this.refreshCartCount();
  };

  deleteEntireCart = () => {
    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/DeleteCart",
      type: "POST",

      data: {
        Order_ID: CartDetails["ORDER_ID"],
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        // //erasing the cookies
        // UtilObject.eraseCookie("ORDER_ID");
        // $.ajax({
        //   url: baseURL + "api/customer/CustomerCookies/unsetSessionValues",
        //   type: "POST",
        //   async: false,
        //   data: {
        //     unset: "ORDER_ID",
        //   },
        //   success: (result) => {
        //
        //   },
        // });
      },
      error: (err) => {},
    });
    CartObject.notifyCartUpdate();
  };
}
